/** @format */

import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import { Row, Col } from "react-bootstrap";
import SelectDropdown from "../UI/SelectDropdown";
import CustomButton from "../UI/CustomButton/inedx";
import ProgressBar from "../UI/ProgressBar";
import ListBox from "./listBox";
import { useHistory, useParams } from "react-router-dom";
import StepOne from "./Steps/StepOne";
import StepTwo from "./Steps/StepTwo";
import StepThree from "./Steps/StepThree";
import StepFour from "./Steps/StepFour";
import StepFive from "./Steps/StepFive";
import BackIcon from "../../assets/Icon/back.png";
import ArrowRightAlt from "../../assets/Icon/back.svg";
import {
  averagePerHour,
  calcHourly,
  calcListing,
  calcProfit,
  profitMargin,
} from "./Steps/calc";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  calculatorSaveAPI,
  editCalculator,
  getCalculator,
} from "../../redux/actions/CalculatorAction";
import GetUser from "../../services/get-user";
import AuthService from "../../services/auth";
import { calculatorDataSelector } from "../../redux/selectors/CalculatorSelectors";
import {
  apiToLocalObject,
  getCalcType,
  getParameterByName,
  InitialErrorState,
  InitialState,
  localToApiObject,
} from "./helper";
import CalculatorSetting from "./CalculatorSetting";
import useWindowSize from "../../hooks/useWindowSize";
import CalculationSavedModal from "./CalculationSavedModal";
import MobileCalculator from "./MobileCalculator";

interface CustomizedState {
  stream: number;
}

const Calculators = () => {
  const history = useHistory();
  const { location } = history as any;
  const statevars = location.state as any;
  const dispatch = useDispatch();
  const currentStepRef = useRef<any>();
  const [currentStep, setCurrentStep] = useState(
    statevars?.state?.isTutorial ? 5 : 1,
  );
  const [isCalculate, setIsCalculate] = useState(false);
  const [calculatorType, setCalculatorType] = useState("calc-1");
  const [calculationSave, setCalculationSave] = useState(0);
  const calculatorData = useSelector(calculatorDataSelector);
  const [isReset, setIsReset] = useState(false);
  const userData = GetUser();
  const params = useParams<any>();
  const { width = 0 } = useWindowSize();
  const [data, setData] = useState(InitialState);
  const [dataError, setDataError] = useState(InitialErrorState);
  const localStorageCalcData = JSON.parse(
    localStorage.getItem("calculatorData") as any,
  );
  const refData = useRef<any>();
  const calcId = getParameterByName("id");

  useEffect(() => {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
    if (location.state) {
      sessionStorage.setItem("state", JSON.stringify(location.state));
    } else {
      const state = sessionStorage.getItem("state");

      if (state) {
        location.state = JSON.parse(state);
      }
    }
  }, []);

  useEffect(() => {
    currentStepRef.current = currentStep;
  }, [currentStep]);

  useEffect(() => {
    if (!calculatorData?.data?.length)
      dispatch(getCalculator({ userID: userData.userID }));
  }, []);

  useEffect(() => {
    if (calcId) {
      const selectedCalc = calculatorData.data.find(
        (val) => val._id === calcId,
      );
      if (selectedCalc) {
        // @ts-ignore
        setCalculatorType(setCalcType(selectedCalc.type));
        const calcData = apiToLocalObject(selectedCalc);
        setData(calcData);
      }
    }
  }, [calcId, calculatorData.data]);

  const isWagePerHour = calculatorType === "calc-4";
  const isStep5 = calculatorType === "calc-5";
  const [isEditMode, setIsEditMode] = useState(false);
  useEffect(() => {
    if (calculationSave === 1) {
      setTimeout(() => {
        setCalculationSave(2);
      }, 1000);
    }
  }, [calculationSave]);

  useEffect(() => {
    if (!localStorageCalcData) localStorage.setItem("calculatorData", "[]");
  }, []);

  const handleBlur = (useRefVal = false) => {
    const val = useRefVal ? refData.current : data;
    switch (calculatorType) {
      case "calc-1":
        return calcProfit(val, setData, isEditMode);
      case "calc-2":
        return calcListing(val, setData, isEditMode);
      case "calc-3":
        return calcHourly(val, setData, isEditMode);
      case "calc-4":
        return averagePerHour(val, setData, isEditMode);
      case "calc-5":
        return profitMargin(val, setData, isEditMode);
    }
  };

  useEffect(() => {
    handleBlur();
  }, [isReset]);

  const getProgressCount = () => {
    if (isCalculate) return 100;
    switch (currentStep) {
      case 1:
        return isStep5 ? 30 : 14;
      case 2:
        return isStep5 ? 60 : 29;
      case 3:
        return isStep5 ? 90 : 48;
      case 4:
        return 60;
      case 5:
        return 75;
    }
  };
  const setCurrent = (count) => {
    if (count === 6 || (isStep5 && count === 4)) {
      handleBlur(true);
      setTimeout(() => {
        setIsCalculate(true);
      }, 200);
      setCalculationSave(0);
    } else if (count < 6) {
      setCurrentStep(count);
      setIsCalculate(false);
    }
  };
  const handleEnter = ({ code }) => {
    if (["Enter", "NumpadEnter"].includes(code)) {
      handleNextStep({ step: undefined });
    }
  };
  const renderSteps = () => {
    switch (currentStep) {
      case 1:
        return (
          <StepOne
            data={data}
            setData={setData}
            calculatorType={calculatorType}
            handleBlur={handleBlur}
            dataError={dataError}
            setDataError={setDataError}
            handleEnter={handleEnter}
          />
        );
      case 2:
        if (isStep5)
          return (
            <StepFive
              isCalculate={isCalculate}
              setIsCalculate={setIsCalculate}
              data={data}
              setData={setData}
              calculatorType={calculatorType}
              isEditMode={isEditMode}
              setIsEditMode={setIsEditMode}
              handleBlur={handleBlur}
              dataError={dataError}
              setDataError={setDataError}
              handleEnter={handleEnter}
              isWagePerHour={isWagePerHour}
              isStep2
            />
          );
        return (
          <StepTwo
            data={data}
            setData={setData}
            calculatorType={calculatorType}
            handleBlur={handleBlur}
            dataError={dataError}
            setDataError={setDataError}
            handleEnter={handleEnter}
          />
        );
      case 3:
        if (isStep5)
          return (
            <StepFour
              data={data}
              setData={setData}
              calculatorType={calculatorType}
              handleBlur={handleBlur}
              dataError={dataError}
              setDataError={setDataError}
              handleEnter={handleEnter}
              isStep3
            />
          );
        return (
          <StepThree
            data={data}
            setData={setData}
            calculatorType={calculatorType}
            handleBlur={handleBlur}
            dataError={dataError}
            setDataError={setDataError}
            handleEnter={handleEnter}
          />
        );
      case 4:
        return (
          <StepFour
            data={data}
            setData={setData}
            calculatorType={calculatorType}
            handleBlur={handleBlur}
            dataError={dataError}
            setDataError={setDataError}
            handleEnter={handleEnter}
            isStep3={false}
          />
        );
      case 5:
        return (
          <StepFive
            isCalculate={isCalculate}
            setIsCalculate={setIsCalculate}
            data={data}
            setData={setData}
            calculatorType={calculatorType}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            handleBlur={handleBlur}
            dataError={dataError}
            setDataError={setDataError}
            handleEnter={handleEnter}
            isWagePerHour={isWagePerHour}
            isStep2={false}
          />
        );
    }
  };

  const handleReset = () => {
    const updateData = {
      ...data,
    };

    const dataVal = {
      ...updateData,
      shipping: "0",
      averagePerHour: "0",
      creditCardFee: "0",
      depopShippingLabelFee: "0",
      transactionFee: "0",
      commissionFee: "0",
      listingFee: "0",
      paymentProcessing: "0",
      selling: "0",
      serviceFee: "0",
      otherFee: "0",
      profit: "0",
      isEdit: false,
    };
    if (calculatorType === "calc-2") {
      dataVal.profit = data.profit;
      dataVal.listingPrice = "0";
    }
    setIsCalculate(false);
    setData(dataVal);
    setIsReset(!isReset);
  };

  const handleNextStep = ({ step }) => {
    const activeStep = step || currentStepRef.current;

    // Step validation
    if (activeStep >= 1) {
      if (!calculatorType) {
        toast("Select Calculator type", {
          type: "error",
          position: "bottom-left",
          toastId: "Calculator_type",
        });
        setDataError({ ...dataError, calculatorTypeError: true });
        setCurrentStep(1);
        return;
      }
      if (
        !refData?.current?.listingPrice &&
        ["calc-1", "calc-3"].includes(calculatorType)
      ) {
        toast("Enter your listing price", {
          type: "error",
          position: "bottom-left",
          toastId: "your_listing_price",
        });
        setDataError({ ...dataError, listingPriceError: true });
        setCurrentStep(1);
        return;
      }
      if (!refData?.current?.profit && ["calc-2"].includes(calculatorType)) {
        toast("Enter your profit product", {
          type: "error",
          position: "bottom-left",
          toastId: "your_profit_product",
        });
        setDataError({ ...dataError, profitError: true });
        setCurrentStep(1);
        return;
      }

      if (!refData?.current?.materials && ["calc-5"].includes(calculatorType)) {
        toast("Enter your product cost", {
          type: "error",
          position: "bottom-left",
          toastId: "product_cost_input",
        });
        setDataError({ ...dataError, materialsError: true });
        setCurrentStep(1);
        return;
      }
      if (activeStep === 1) {
        setCurrentStep(1);
      }
    }
    if (activeStep >= 2) {
      if (!refData?.current?.profit && ["calc-3"].includes(calculatorType)) {
        toast("Enter your profit", {
          type: "error",
          position: "bottom-left",
          toastId: "your_profit_input",
        });
        setDataError({ ...dataError, profitError: true });
        setCurrentStep(2);
        return;
      }
      if (activeStep === 2) {
        setCurrentStep(2);
      }
    }

    if (activeStep >= 3) {
      if (activeStep === 3) {
        setCurrentStep(3);
      }
    }
    if (activeStep >= 4 && !isStep5) {
      if (!refData?.current?.materials) {
        toast("Enter materials", {
          type: "error",
          position: "bottom-left",
          toastId: "materials_input",
        });
        setDataError({ ...dataError, materialsError: true });
        setCurrentStep(4);
        return;
      }
      if (activeStep === 4) {
        setCurrentStep(4);
      }
    }
    if (activeStep >= 5 && !isStep5) {
      if (!refData?.current?.serviceProviders) {
        toast("Place select service provider ", {
          type: "error",
          position: "bottom-left",
          toastId: "select_service_provider",
        });
        setDataError({ ...dataError, serviceProvidersError: true });
        setCurrentStep(5);
        return;
      }
      if (activeStep === 5) {
        setCurrentStep(5);
      }
    }

    let stepNumber = currentStepRef.current;
    if (isWagePerHour && currentStepRef.current === 1) stepNumber = 2;
    const setStep = step ? step : stepNumber + 1;
    setCurrent(setStep);
  };

  const handleBack = () => {
    if (currentStep === 1) return;
    let setCurrentStep = currentStep - 1;
    if (isWagePerHour && currentStep === 3) setCurrentStep = 1;
    setCurrent(setCurrentStep);
  };
  const handlePageBack = () => {
    history.push(`/stream/${params?.name}`);
  };

  const setCalcType = (type) => {
    switch (type) {
      case "Profit":
        return "calc-1";
      case "Listing Price":
        return "calc-2";
      case "Labor Value":
        return "calc-3";
      case "Wage per Hour":
        return "calc-4";
      case "Profit Margin":
        return "calc-5";
    }
  };

  const handleSaveCalculation = () => {
    setCalculationSave(1);
    const obj = localToApiObject(refData.current);
    const payload = {
      incomeStream: statevars?.stream,
      result: 1,
      date: new Date(),
      name: data.calcName,
      type: getCalcType(calculatorType),
      userID: userData.userID,
      ...obj,
    };
    if (calcId) {
      dispatch(editCalculator({ calcID: calcId, ...payload }));
      return;
    }
    dispatch(calculatorSaveAPI(payload));
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      if (refData?.current?.serviceProviders && currentStepRef.current > 2) {
        if (refData?.current?.calculationSave === 2) {
          sessionStorage.setItem("option", "saved");
          handlePageBack();
          return;
        }
        if (refData?.current?.isCalculate) return handleSaveCalculation();
        handleNextStep({ step: 6 });
      }
    }
  };

  useEffect(() => {
    refData.current = { ...data, currentStep, calculationSave, isCalculate };
  }, [data, currentStep, calculationSave, isCalculate]);
  return (
    <div className="calculator-wrapper page-space">
      <div className="d-flex justify-content-between">
        <h3 className="page-title m-0 d-flex align-items-center calc-page-title">
          <img
            src={BackIcon}
            className="back-icon pointer-cursor top-side desktop"
            onClick={handlePageBack}
          />
          {width > 600 ? "Pricing Calculators" : "Calculator"}
          <CalculatorSetting />
        </h3>
        <CustomButton
          onClick={() => history.push("/calculateSummarySheet")}
          size="large"
          secondary
          className="next-button desktop"
          disabled={statevars?.state?.isTutorial}
        >
          View calculator summary sheet
        </CustomButton>
      </div>
      <div className="mt-3 mt-md-5">
        <SelectDropdown
          label="Select Calculator"
          width={210}
          value={calculatorType}
          isDisable={statevars?.state?.isTutorial}
          options={[
            {
              value: "calc-1",
              label: "Calculate Profit",
            },
            {
              value: "calc-2",
              label: "Calculate Listing Price",
            },
            {
              value: "calc-3",
              label: "Calculate Labor Value",
            },
            {
              value: "calc-4",
              label: "Wage per Hour",
            },
            {
              value: "calc-5",
              label: "Profit Margin",
            },
          ]}
          onChange={({ target: { value } }) => {
            setCalculatorType(value);
            setCurrentStep(1);
            setData(InitialState);
            setIsCalculate(false);
          }}
        />
      </div>
      {width > 600 ? (
        <div className="cal-background border-radius p-4 py-5 mt-4">
          <Row>
            <Col lg={7} md={6} className="right-border calc">
              {currentStep === 1 ? null : ( // <HomeIcon className="mr-2 pointer-cursor" />
                <p className="back-calc-link" onClick={handleBack}>
                  <img
                    src={ArrowRightAlt}
                    className="back-icon pointer-cursor"
                    alt="ArrowRightAlt"
                  />
                  Previous question
                </p>
              )}
              <h4 className="d-flex align-items-center calc-title">
                {getCalcType(calculatorType)}
              </h4>
              <p className="calc-sub-title">
                {calculatorType === "calc-1" &&
                  "Know how much you make per product"}
                {calculatorType === "calc-2" &&
                  "Know the listing price for your product"}
                {calculatorType === "calc-3" &&
                  "Know how much to value your time"}
                {calculatorType === "calc-4" && "Wage per hour calculator"}
                {isStep5 && "Know how much your profit margin is"}
              </p>
              {renderSteps()}
              <div
                className="footer-btn-wrapper"
                style={
                  currentStep === 1 ? { marginTop: width > 600 ? 76 : 20 } : {}
                }
              >
                <div
                  className="d-flex align-items-center"
                  style={{ marginTop: 10 }}
                >
                  {(currentStep === 5 || (isStep5 && currentStep === 3)) &&
                    data.isEdit && (
                      <CustomButton
                        size="large"
                        secondary
                        className="mr-2"
                        onClick={handleReset}
                      >
                        Reset
                      </CustomButton>
                    )}

                  <CustomButton
                    onClick={handleNextStep}
                    size="large"
                    className="next-button"
                    disabled={statevars?.state?.isTutorial}
                  >
                    {isStep5
                      ? currentStep === 3
                        ? "Calculate"
                        : "Next"
                      : currentStep === 5
                      ? "Calculate"
                      : "Next"}
                  </CustomButton>
                  <div className="mx-3 enter-button desktop">
                    <span>OR</span>&nbsp;press ENTER
                  </div>
                </div>
                <div
                  className="position-relative mr-3"
                  style={{ marginTop: 10 }}
                >
                  <ProgressBar
                    progressCountClassName="calculator-progress"
                    width={getProgressCount()}
                  />
                </div>
              </div>
            </Col>
            <ListBox
              data={data}
              step={currentStep}
              handleNextStep={handleNextStep}
              calculatorType={calculatorType}
              isWagePerHour={isWagePerHour}
            />
          </Row>
        </div>
      ) : (
        <MobileCalculator
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
          isCalculate={isCalculate}
          setIsCalculate={setIsCalculate}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          isWagePerHour={isWagePerHour}
          handleNextStep={handleNextStep}
          isStep5={isStep5}
        />
      )}
      {isCalculate && (
        <CalculationSavedModal
          isCalculate={isCalculate}
          setIsCalculate={setIsCalculate}
          calculatorType={calculatorType}
          calculationSave={calculationSave}
          isStep5={isStep5}
          data={data}
          setData={setData}
          handleBlur={handleBlur}
          handleSaveCalculation={handleSaveCalculation}
        />
      )}
    </div>
  );
};

export default Calculators;
